export const Wheel = {
  WD4: 4,
  WD6: 6,
};

export default [
  { key: Wheel.WD4, label: "4 WD" },
  { key: Wheel.WD6, label: "6 WD" },
];
